var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28184 4.9406C7.38797 5.04673 7.5275 5.10011 7.66678 5.10011C7.80606 5.10011 7.94558 5.04673 8.05171 4.9406C8.26454 4.72777 8.26454 4.38356 8.05171 4.17073L4.9406 1.05962C4.72777 0.846792 4.38356 0.846792 4.17073 1.05962L1.05962 4.17073C0.846792 4.38356 0.846792 4.72777 1.05962 4.9406C1.27245 5.15343 1.61666 5.15343 1.82949 4.9406L4.55567 2.21442L7.28184 4.9406Z",
    fill: "#3E3F42",
    stroke: "#3E3F42",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00937 8.66412C4.00937 8.79519 4.07988 8.90641 4.17933 8.98151C4.27871 9.05656 4.41146 9.1 4.55382 9.1C4.69618 9.1 4.82893 9.05656 4.92831 8.98151C5.02776 8.90641 5.09826 8.79519 5.09826 8.66412V1.33588C5.09826 1.20494 5.02773 1.09375 4.92833 1.01863C4.82899 0.943552 4.69623 0.9 4.55382 0.9C4.41141 0.9 4.27865 0.943552 4.17931 1.01863C4.07991 1.09375 4.00937 1.20494 4.00937 1.33588V8.66412Z",
    fill: "#3E3F42",
    stroke: "#3E3F42",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrowUp);
export default __webpack_public_path__ + "static/media/sorting-arrow-up.5302d97b485286fb49c192d00ce3f180.svg";
export { ForwardRef as ReactComponent };